import { useContext } from "react";
import { RoleRedcrossPermission } from "../Context/AuthRedcrossContext";

const useAuthRedcross = () => {
  const context = useContext(RoleRedcrossPermission);
  if (!context)
    throw new Error("PDFEditor Context must be use inside PDFEditor Provider");
  return context;
};

export default useAuthRedcross;
